import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Mail, MessageCircle, Play, CheckCheck } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
const FACES = ['https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=600&q=80'];
function LinkedInMock({
  delay
}: {
  delay: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay,
    duration: 0.4
  }} className="flex flex-col bg-white rounded-lg border border-black/10 shadow-sm overflow-hidden h-full" data-id="element-146">
      <div className="flex items-center gap-1.5 p-2 border-b border-black/5" data-id="element-147">
        <Linkedin className="w-4 h-4 text-[#0A66C2]" data-id="element-148" />
        <span className="text-[#0A66C2] font-bold text-xs" data-id="element-149">
          LinkedIn Campaign
        </span>
      </div>
      <div className="p-3 flex-1 flex flex-col gap-2" data-id="element-150">
        <div className="flex items-center gap-2" data-id="element-151">
          <img src={FACES[0]} className="w-8 h-8 rounded-full object-cover object-top" alt="Avatar" data-id="element-152" />
          <div className="leading-none" data-id="element-153">
            <div className="font-bold text-sm text-[var(--fg)]" data-id="element-154">
              LEO Pharma UK
            </div>
            <div className="text-xs text-[var(--muted)] mt-0.5" data-id="element-155">Sponsored</div>
          </div>
        </div>
        <div className="text-sm text-[var(--fg)] leading-tight" data-id="element-156">
          New UK insights on Atopic Dermatitis management. Watch the latest
          5-min episode now 👇
        </div>
        <div className="relative flex-1 rounded bg-black overflow-hidden min-h-[6rem]" data-id="element-157">
          <img src={FACES[0]} className="absolute inset-0 w-full h-full object-cover object-top opacity-80" alt="Video thumbnail" data-id="element-158" />
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-159">
            <div className="w-8 h-8 rounded-full bg-white/90 flex items-center justify-center" data-id="element-160">
              <Play className="w-4 h-4 fill-[#0A66C2] text-[#0A66C2] ml-0.5" data-id="element-161" />
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}
function WhatsAppMock({
  delay
}: {
  delay: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay,
    duration: 0.4
  }} className="flex flex-col bg-[#EFEAE2] rounded-lg border border-black/10 shadow-sm overflow-hidden h-full" data-id="element-162">
      <div className="flex items-center gap-1.5 p-2 bg-[#075E54] text-white" data-id="element-163">
        <MessageCircle className="w-4 h-4" data-id="element-164" />
        <span className="font-bold text-xs" data-id="element-165">WhatsApp Rep Outreach</span>
      </div>
      <div className="p-3 flex-1 flex flex-col justify-end" data-id="element-166">
        <div className="bg-[#DCF8C6] rounded-lg rounded-tr-none p-2 shadow-sm self-end max-w-[90%]" data-id="element-167">
          <div className="text-sm text-[var(--fg)] leading-tight mb-2" data-id="element-168">
            Hi Dr. Smith! Check out this quick 5-min UK update on AD treatments
            🎥
          </div>
          <div className="relative h-24 rounded bg-black overflow-hidden mb-1" data-id="element-169">
            <img src={FACES[0]} className="absolute inset-0 w-full h-full object-cover object-top opacity-80" alt="Video thumbnail" data-id="element-170" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-171">
              <div className="w-8 h-8 rounded-full bg-white/90 flex items-center justify-center" data-id="element-172">
                <Play className="w-4 h-4 fill-[#25D366] text-[#25D366] ml-0.5" data-id="element-173" />
              </div>
            </div>
          </div>
          <div className="flex justify-end items-center gap-1" data-id="element-174">
            <span className="text-[0.65rem] text-black/40" data-id="element-175">10:42</span>
            <CheckCheck className="w-3 h-3 text-[#34B7F1]" data-id="element-176" />
          </div>
        </div>
      </div>
    </motion.div>;
}
function EmailMock({
  delay
}: {
  delay: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay,
    duration: 0.4
  }} className="flex flex-col bg-white rounded-lg border border-black/10 shadow-sm overflow-hidden h-full" data-id="element-177">
      <div className="flex items-center gap-1.5 p-2 border-b border-black/5" data-id="element-178">
        <Mail className="w-4 h-4 text-[var(--brand-green)]" data-id="element-179" />
        <span className="text-[var(--brand-green)] font-bold text-xs" data-id="element-180">
          Email Newsletter
        </span>
      </div>
      <div className="p-2 border-b border-black/5 bg-black/5" data-id="element-181">
        <div className="text-xs text-[var(--muted)]" data-id="element-182">
          <span className="font-semibold text-[var(--fg)]" data-id="element-183">From:</span> DERMX UK
          Updates
        </div>
        <div className="text-xs text-[var(--muted)] truncate" data-id="element-184">
          <span className="font-semibold text-[var(--fg)]" data-id="element-185">Subject:</span> New
          Episode: AD Barriers to Care
        </div>
      </div>
      <div className="p-3 flex-1 flex flex-col" data-id="element-186">
        <div className="relative flex-1 rounded bg-black overflow-hidden min-h-[6rem]" data-id="element-187">
          <img src={FACES[0]} className="absolute inset-0 w-full h-full object-cover object-top opacity-80" alt="Video thumbnail" data-id="element-188" />
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/20" data-id="element-189">
            <div className="w-8 h-8 rounded-full bg-[var(--brand-green)] flex items-center justify-center mb-1" data-id="element-190">
              <Play className="w-4 h-4 fill-white text-white ml-0.5" data-id="element-191" />
            </div>
            <span className="text-white font-bold text-xs" data-id="element-192">WATCH EPISODE</span>
          </div>
        </div>
      </div>
    </motion.div>;
}
export function Slide4UKEngagement({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--surface)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-193">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0" data-id="element-194">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-195">
          Top-of-Funnel Engagement
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08] max-w-5xl" data-id="element-196">
          Deploying episodes across{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-197">
            multiple UK channels.
          </span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-3 gap-[clamp(1rem,2vw,2rem)] min-h-0" data-id="element-198">
        <LinkedInMock delay={0.4} data-id="element-199" />
        <WhatsAppMock delay={0.6} data-id="element-200" />
        <EmailMock delay={0.8} data-id="element-201" />
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 0.6
    }} className="mt-[clamp(1.5rem,2.5vw,2.5rem)] bg-[var(--brand-green)] rounded-2xl p-[clamp(1.5rem,2vw,2rem)] flex items-center justify-between gap-6 flex-shrink-0 shadow-lg" data-id="element-202">
        <div data-id="element-203">
          <p className="text-white font-bold text-[clamp(1.25rem,1.8vw,1.75rem)] leading-tight" data-id="element-204">
            Meet UK HCPs where they are.
          </p>
          <p className="text-white/80 text-[clamp(0.95rem,1.1vw,1.15rem)] mt-1" data-id="element-205">
            Short, engaging hooks drive traffic to the full episodes, initiating
            the journey.
          </p>
        </div>
      </motion.div>
    </div>;
}